module.exports = __webpack_public_path__ + "2024611:ed75de4ab11883afa87d/img/Till-This-Day-Tile_no-spot.44aac0a.png";